import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef, useState } from "react"
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined"
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined"
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined"
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined"
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined"
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined"
import SimpleBar from "simplebar-react"
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link, useNavigate } from "react-router-dom"
import { withTranslation } from "react-i18next"
import webMdIcon from "../../assets/images/icons/webmd.png"
import yelpIcon from "../../assets/images/icons/yelp.svg"
import logo1 from "../../assets/images/logo/logo-color.png"
import logo2 from "../../assets/images/logo/logo-light.png"
import healthGradeIcon from "../../assets/images/icons/healthgrade.png"
import GoogleAnalyticsIcon from "../../assets/images/icons/analytics.png"
import VitalsIcon from "../../assets/images/icons/vitals.png"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { changeSidebarType } from "store/actions"

const SidebarContent = props => {
  const navigate = useNavigate()
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const dispatch = useDispatch()
  const leftSideBarType = useSelector(state => state.Layout.leftSideBarType)
  const [isSidebarClosed, setIsSidebarClosed] = useState(false)
  const [hoveredItem, setHoveredItem] = useState(null)
  const sidebarWidth = leftSideBarType === "condensed" ? 85 : 260
  const buttonSize = 30
  const mode = useSelector(state => state.Layout.layoutMode)
  const mediaEngagementPaths = [
    "/dashboard/facebook",
    "/dashboard/instagram",
    "/dashboard/yelp",
    "/dashboard/healthgrade",
    "/dashboard/google-analytics",
    "/dashboard/vitals",
  ]
  const tToggle = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed"))
    } else {
      dispatch(changeSidebarType("default"))
    }
  }

  const userData = useSelector(state => state.Login.userData)
  const ref = useRef()
  const currentPath = props.router.location.pathname

  // Theme colors
  const getThemeColors = () => {
    if (mode === "dark") {
      return {
        text: "#fff",
        textSecondary: "white",
        hoverBg: "#2a2f3a",
        hoverText: "#fff",
        activeBg: "#3a4556",
        activeText: "white",
        activeBorder: "#fff",
        background: "#252F40",
        boxShadow: "0px 6px 17px -8px rgba(255,255,255,0.75)",
      }
    } else {
      return {
        text: "black",
        textSecondary: "black",
        hoverBg: "#f1f3f7",
        hoverText: "#383c40",
        activeBg: "white",
        activeText: "black", // dark text on light active bg
        activeBorder: "#2990DF",
        background: "#fff",
        boxShadow: "0px 6px 17px -8px rgba(41,144,223,0.75)",
      }
    }
  }

  const colors = getThemeColors()

  // Menu item base style
  // Menu item base style
  const getMenuItemStyle = (isActive, itemId) => {
    const isHovered = hoveredItem === itemId
    return {
      color: colors.activeText,
      backgroundColor:
        isHovered || isActive ? colors.background : colors.background,
      padding: "12px 20px",
      display: "flex",
      alignItems: "center",
      textDecoration: "none",
      marginTop: "5px",
      borderRadius: "5px",
      boxShadow: isActive ? colors.boxShadow : "none",
      border: isActive
        ? `1px solid ${colors.activeBorder}`
        : isHovered
          ? `1px solid ${colors.activeBorder}`
          : "1px solid transparent",
      transition: "all 0.2s ease",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: isActive ? "600" : "500",
      zIndex: "100px",
    }
  }

  // Submenu item style
  const getSubMenuItemStyle = (isActive, itemId) => {
    const isHovered = hoveredItem === itemId

    return {
      color: isActive
        ? colors.activeText // active text per theme
        : isHovered
          ? colors.hoverText // hover text per theme
          : colors.textSecondary, // default text per theme
      backgroundColor: "transparent",
      // padding: "10px 20px 10px 55px",
      display: "flex",
      alignItems: "center",
      textDecoration: "none",
      width: "100%",
      marginTop: "5px",
      boxShadow: isActive ? "0px 6px 17px -8px rgba(41,144,223,0.75)" : "none",
      borderRadius: "5px",
      border: isActive
        ? `1px solid ${colors.activeBorder}`
        : isHovered
          ? `1px solid ${colors.activeBorder}`
          : "1px solid transparent",
      transition: "all 0.2s ease",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: isActive ? "600" : "400",
    }
  }

  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show")
        const parent3 = parent2.parentElement

        if (parent3) {
          parent3.classList.add("mm-active")
          parent3.childNodes[0].classList.add("mm-active")
          const parent4 = parent3.parentElement
          if (parent4) {
            parent4.classList.add("mm-show")
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show")
              parent5.childNodes[0].classList.add("mm-active")
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active")
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement
            if (parent4) {
              parent4.classList.remove("mm-show")
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show")
                parent5.childNodes[0].classList.remove("mm-active")
              }
            }
          }
        }
      }
    }
  }

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [props.router.location.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          position: "sticky",
          top: 0,
          height: "100vh",
          backgroundColor: colors.background,
          borderRadius: "20px",
        }}
      >
        <SimpleBar style={{ flex: 1 }} ref={ref}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "10px 20px",
            }}
          >
            <img
              style={{ width: "100px", height: "100px", borderRadius: "8px" }}
              src={mode === "dark" ? logo2 : logo1}
              alt="Logo"
              className="navbar-brand-logo"
            />
          </div>

          <div id="sidebar-menu">
            <ul
              className="metismenu list-unstyled"
              id="side-menu"
              style={{
                listStyle: "none",
                px: 2,
                margin: 0,
                backgroundColor: mode === "dark" ? "#252F40" : "white", // theme background
                borderLeft: `1px solid ${colors.border}`,
              }}
            >
              <li style={{ margin: "2px 0" }}>
                <Link
                  to="/dashboard"
                  style={getMenuItemStyle(
                    currentPath === "/dashboard",
                    "dashboard",
                  )}
                  onMouseEnter={() => setHoveredItem("dashboard")}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <DashboardOutlinedIcon
                    style={{ marginRight: "10px", fontSize: "20px" }}
                  />
                  <span>{props.t("Dashboard")}</span>
                </Link>
              </li>

              <li style={{ margin: "2px 0" }}>
                <Link
                  to="/integrations"
                  style={getMenuItemStyle(
                    mediaEngagementPaths.includes(currentPath),
                    "integrations",
                  )}
                  className="has-arrow"
                  onMouseEnter={() => setHoveredItem("integrations")}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <CollectionsOutlinedIcon
                    style={{
                      marginRight: "10px",
                      fontSize: "20px",
                      color: mode === "dark" ? "#fff" : "black",
                    }}
                  />
                  <span
                    style={{
                      color: mode === "dark" ? "#fff" : "black",
                    }}
                  >
                    {props.t("Media Engagements")}
                  </span>
                </Link>
                <ul
                  style={{
                    listStyle: "none",
                    padding: "5px",
                    marginTop: "2px",
                    backgroundColor: colors.background,
                    borderRadius: "8px",
                    width: "230px",
                  }}
                >
                  {!(
                    activeOrganization?.FacebookIntegrations[0] ||
                    activeOrganization?.InstagramIntegrations[0] ||
                    activeOrganization?.YelpIntegrations[0] ||
                    activeOrganization?.HealthgradeIntegrations[0] ||
                    activeOrganization?.GoogleAnalyticsIntegrations[0] ||
                    activeOrganization?.VitalsIntegrations[0]
                  ) ? (
                    <li>
                      <div
                        style={{
                          margin: "10px",
                          padding: "18px",
                          backgroundColor: mode === "dark" ? "red" : "#fff3cd",
                          color: mode === "dark" ? "#ffc107" : "#856404",
                          borderRadius: "4px",
                          fontSize: "12px",
                          borderLeft: `3px solid ${mode === "dark" ? "#ffc107" : "#856404"}`,
                        }}
                      >
                        {props.t(
                          "No media integrations found. Please configure your integrations from Integrations page under admin console.",
                        )}
                      </div>
                    </li>
                  ) : (
                    <>
                      {activeOrganization.FacebookIntegrations[0] && (
                        <li>
                          <Link
                            to="/dashboard/facebook"
                            style={getSubMenuItemStyle(
                              currentPath === "/dashboard/facebook",
                              "facebook",
                            )}
                            onMouseEnter={() => setHoveredItem("facebook")}
                            onMouseLeave={() => setHoveredItem(null)}
                          >
                            <i
                              className="mdi mdi-facebook"
                              style={{
                                marginRight: "8px",
                                fontSize: "16px",
                                color: mode === "dark" ? "#fff" : "#050409",
                              }}
                            ></i>
                            {props.t("Facebook")}
                          </Link>
                        </li>
                      )}
                      {activeOrganization.InstagramIntegrations[0] && (
                        <li>
                          <Link
                            to="/dashboard/instagram"
                            style={getSubMenuItemStyle(
                              currentPath === "/dashboard/instagram",
                              "instagram",
                            )}
                            onMouseEnter={() => setHoveredItem("instagram")}
                            onMouseLeave={() => setHoveredItem(null)}
                          >
                            <i
                              className="mdi mdi-instagram"
                              style={{
                                marginRight: "8px",
                                fontSize: "16px",
                                color: mode === "dark" ? "#fff" : "#050409",
                              }}
                            ></i>
                            {props.t("Instagram")}
                          </Link>
                        </li>
                      )}
                      {activeOrganization.YelpIntegrations[0] && (
                        <li>
                          <Link
                            to="/dashboard/yelp"
                            style={getSubMenuItemStyle(
                              currentPath === "/dashboard/yelp",
                              "yelp",
                            )}
                            onMouseEnter={() => setHoveredItem("yelp")}
                            onMouseLeave={() => setHoveredItem(null)}
                          >
                            <img
                              src={yelpIcon}
                              alt="yelp"
                              style={{
                                width: "16px",
                                height: "16px",
                                filter: mode === "dark" ? "invert(1)" : "none",
                                marginRight: "8px",
                              }}
                            />
                            {props.t("Yelp")}
                          </Link>
                        </li>
                      )}
                      {activeOrganization.HealthgradeIntegrations[0] && (
                        <li>
                          <Link
                            to="/dashboard/healthgrade"
                            style={getSubMenuItemStyle(
                              currentPath === "/dashboard/healthgrade",
                              "healthgrade",
                            )}
                            onMouseEnter={() => setHoveredItem("healthgrade")}
                            onMouseLeave={() => setHoveredItem(null)}
                          >
                            <img
                              src={healthGradeIcon}
                              alt="healthgrade"
                              style={{
                                width: "16px",
                                height: "16px",
                                marginRight: "8px",
                              }}
                            />
                            {props.t("HealthGrade")}
                          </Link>
                        </li>
                      )}
                      {activeOrganization.GoogleAnalyticsIntegrations[0] && (
                        <li>
                          <Link
                            to="/dashboard/google-analytics"
                            style={getSubMenuItemStyle(
                              currentPath === "/dashboard/google-analytics",
                              "analytics",
                            )}
                            onMouseEnter={() => setHoveredItem("analytics")}
                            onMouseLeave={() => setHoveredItem(null)}
                          >
                            <img
                              src={GoogleAnalyticsIcon}
                              alt="analytics"
                              style={{
                                width: "16px",
                                height: "16px",
                                marginRight: "8px",
                              }}
                            />
                            {props.t("Analytics")}
                          </Link>
                        </li>
                      )}
                      {activeOrganization.VitalsIntegrations[0] && (
                        <li>
                          <Link
                            to="/dashboard/vitals"
                            style={getSubMenuItemStyle(
                              currentPath === "/dashboard/vitals",
                              "vitals",
                            )}
                            onMouseEnter={() => setHoveredItem("vitals")}
                            onMouseLeave={() => setHoveredItem(null)}
                          >
                            <img
                              src={
                                mode === "dark"
                                  ? `/logos/vital-dark.png`
                                  : `/logos/vital-light.png`
                              }
                              alt="Vitals"
                              style={{
                                width: "16px",
                                height: "16px",
                                marginRight: "8px",
                              }}
                            />
                            {props.t("Vitals")}
                          </Link>
                        </li>
                      )}
                    </>
                  )}
                </ul>
              </li>

              <li style={{ margin: "2px 0" }}>
                <Link
                  to="/dashboard/campaign"
                  style={getMenuItemStyle(
                    currentPath === "/dashboard/campaign",
                    "campaigns",
                  )}
                  onMouseEnter={() => setHoveredItem("campaigns")}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <CampaignOutlinedIcon
                    style={{ marginRight: "10px", fontSize: "20px" }}
                  />
                  <span>{props.t("Campaigns")}</span>
                </Link>
              </li>

              <li style={{ margin: "2px 0" }}>
                <Link
                  to="/dashboard/customers"
                  style={getMenuItemStyle(
                    currentPath === "/dashboard/customers",
                    "customers",
                  )}
                  onMouseEnter={() => setHoveredItem("customers")}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <GroupsOutlinedIcon
                    style={{ marginRight: "10px", fontSize: "20px" }}
                  />
                  <span>{props.t("Customers")}</span>
                </Link>
              </li>

              <li style={{ margin: "2px 0" }}>
                <Link
                  to="/dashboard/activities"
                  style={getMenuItemStyle(
                    currentPath === "/dashboard/activities",
                    "activities",
                  )}
                  onMouseEnter={() => setHoveredItem("activities")}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <ArticleOutlinedIcon
                    style={{ marginRight: "10px", fontSize: "20px" }}
                  />
                  <span>{props.t("Activities")}</span>
                </Link>
              </li>

              <li style={{ margin: "2px 0" }}>
                <Link
                  to="/#"
                  style={getMenuItemStyle(
                    currentPath.includes("dashboard/profile") ||
                      currentPath.includes(
                        "dashboard/organizations-list",
                      ) ||
                      currentPath.includes("dashboard/history") ||
                      currentPath.includes("dashboard/integrations"),
                    "admin",
                  )}
                  className="has-arrow"
                  onMouseEnter={() => setHoveredItem("admin")}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <ManageAccountsOutlinedIcon
                    style={{
                      marginRight: "10px",
                      fontSize: "20px",
                      color: mode === "dark" ? "#fff" : "black",
                    }}
                  />
                  <span
                    style={{
                      color: mode === "dark" ? "#fff" : "black",
                    }}
                  >
                    {props.t("Admin Console")}
                  </span>
                </Link>
                <ul
                  className=""
                  style={{
                    listStyle: "none",
                    padding: "5px",
                    marginTop: "2px",
                    backgroundColor: colors.background,
                    borderRadius: "8px",
                    width: "230px",
                  }}
                >
                  <li>
                    <Link
                      to="/dashboard/profile"
                      style={getSubMenuItemStyle(
                        currentPath === "/dashboard/profile",
                        "profile",
                      )}
                      onMouseEnter={() => setHoveredItem("profile")}
                      onMouseLeave={() => setHoveredItem(null)}
                    >
                      <i
                        className="mdi mdi-account-circle-outline"
                        style={{
                          fontSize: "16px",
                          color: mode === "dark" ? "#fff" : "black",
                          marginRight: "0px",
                        }}
                      ></i>
                      {props.t("Account")}
                    </Link>
                  </li>
                  {userData.role === "admin" && (
                    <li>
                      <Link
                        to="/dashboard/office"
                        style={getSubMenuItemStyle(
                          currentPath === "/dashboard/office",
                          "user-mgmt",
                        )}
                        onMouseEnter={() => setHoveredItem("user-mgmt")}
                        onMouseLeave={() => setHoveredItem(null)}
                      >
                        <i
                          className="mdi mdi-office-building-marker"
                          style={{
                            fontSize: "16px",
                            color: mode === "dark" ? "#fff" : "black",
                          }}
                        ></i>
                        {props.t("Office")}
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link
                      to="/dashboard/history"
                      style={getSubMenuItemStyle(
                        currentPath === "/dashboard/history",
                        "history",
                      )}
                      onMouseEnter={() => setHoveredItem("history")}
                      onMouseLeave={() => setHoveredItem(null)}
                    >
                      <i
                        className="mdi mdi-office-building-marker"
                        style={{
                          fontSize: "16px",
                          color: mode === "dark" ? "#fff" : "black",
                        }}
                      ></i>
                      {props.t("History")}
                    </Link>
                  </li>
                  {userData.role === "admin" && (
                    <li>
                      <Link
                        to="/dashboard/integrations"
                        style={getSubMenuItemStyle(
                          currentPath === "/dashboard/integrations",
                          "integration",
                        )}
                        onMouseEnter={() => setHoveredItem("integration")}
                        onMouseLeave={() => setHoveredItem(null)}
                      >
                        <i
                          className="mdi mdi-transit-connection-variant"
                          style={{
                            fontSize: "16px",
                            color: mode === "dark" ? "#fff" : "#495057",
                          }}
                        ></i>
                        {props.t("Integration")}
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            </ul>
          </div>
        </SimpleBar>

        {leftSideBarType !== "condensed" && (
          <div
            style={{
              padding: "15px 10px",
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderTop: `1px solid ${colors.border}`,
            }}
          >
            <p
              style={{
                margin: "0",
                fontFamily: "inter",
                fontWeight: 500,
                fontSize: "12px",
                color: mode === "dark" ? "#b8b9ba" : "#6c757d",
              }}
            >
              © 2025 Reputation Management - Powered by 1click-solutions
            </p>
          </div>
        )}
      </div>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
